import React, { useState,useEffect } from 'react';

import {
  X,
  Activity,
  Baby,
  Brain,
  ClipboardList,
  Droplet,
  Dumbbell,
  Ear,
  Eye,
  FileSearch,
  HeartPulse,
  Hospital,
  Layers,
  ScanLine,
  Slice,
  ShieldCheck,
  Stethoscope,
  Syringe,
  TestTube2,
  Utensils,
  UserCog,
  Wind,
  Copy,
  NotebookText
} from 'lucide-react';

import { cptData, priceSources } from '../../utils/codeData';
import { useData } from '../../hooks/useData';
import { useTheme } from '../../context/ThemeContext';
import { toast } from 'react-hot-toast';
import { addCommas, renderPercentColor } from '../../utils/tools';
import { toastConfig, createCustomToast } from '../../utils/data';
// Icon map for Lucide icons used in this component
const icons = {
  X,
  Activity,
  Baby,
  Brain,
  ClipboardList,
  Droplet,
  Dumbbell,
  Ear,
  Eye,
  FileSearch,
  HeartPulse,
  Hospital,
  Layers,
  ScanLine,
  Slice,
  ShieldCheck,
  Stethoscope,
  Syringe,
  TestTube2,
  Utensils,
  UserCog,
  Wind
};
const CodeSearchTab = ({ code, onCloseClick, markupPercent=150, loading=false }) => {
  const [codeColor, setCodeColor] = useState('#000');
  const [primaryIcon, setPrimaryIcon] = useState(null);
  const [secondaryIcon, setSecondaryIcon] = useState(null);
  const [primaryIconColor, setPrimaryIconColor] = useState('#000');
  const [secondaryIconColor, setSecondaryIconColor] = useState('#000');
  const [section, setSection] = useState('');
  const [sectionDescription, setSectionDescription] = useState('');
  const [subSection, setSubSection] = useState('');
  const [desc, setDesc] = useState('');
  const { theme } = useTheme();
  const { codes } = useData();
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      createCustomToast('Code copied.', theme);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  useEffect(() => {
    
    
    const numCode = parseInt(code, 10);
    let foundSection = null;
    let foundSubsection = null;
    let foundSectionKey = '';
    let foundSubsectionKey = '';
    // Find section
    for (const [sectionKey, section] of Object.entries(cptData)) {
      if (numCode >= section.rangeStart && numCode <= section.rangeEnd) {
        foundSection = section;
        foundSectionKey = sectionKey;
        // Find subsection if exists
        if (section.subsections) {
          for (const [subKey, sub] of Object.entries(section.subsections)) {
            if (numCode >= sub.rangeStart && numCode <= sub.rangeEnd) {
              foundSubsection = sub;
              foundSubsectionKey = subKey;
              break;
            }
          }
        }
        break;
      }
    }
    // Set color and icons
    if (foundSection) {
      setCodeColor(foundSection.color || '#000');
      setPrimaryIcon(foundSection.icon || null);
      setPrimaryIconColor(foundSection.color || '#000');
      setSection(foundSectionKey.replace(/_/g, ' '));
      setSectionDescription(foundSection.description || '');
    } else {
      setCodeColor('#000');
      setPrimaryIcon(null);
      setPrimaryIconColor('#000');
      setSection('');
      setSectionDescription('');
    }
    if (foundSubsection) {
      setSecondaryIcon(foundSubsection.icon || null);
      setSecondaryIconColor(foundSubsection.color || foundSection?.color || '#000');
      setSubSection(foundSubsectionKey.replace(/_/g, ' '));
    } else {
      setSecondaryIcon(null);
      setSecondaryIconColor(foundSection?.color || '#000');
      setSubSection('');
    }
  }, [code]);

  useEffect(() => {
    if (codes[code] !== undefined && desc.length < 1) {
      let d = null;
            for(var key in codes[code].data) {
        if (!d &&codes[code].data[key].desc !== undefined &&
          codes[code].data[key].desc.length > 0 &&
          codes[code].data[key].desc !== "N/A") {
          setDesc(codes[code].data[key].desc);
          d = true;
        }
      }
   
    }
  }, [codes, code]);

  const renderMarkup = (price) => {
    return (price * markupPercent / 100).toFixed(2);
  }

  // Helper to render Lucide icon by name
  const renderLucideIcon = (iconName, color) => {
    if (!iconName) return null;

    const IconComp = icons[iconName];
    if (!IconComp) return null;
    return <IconComp size={20} color={color} style={{ marginRight: 4 }} />;
  };

  return (
    <div className="code-search-tab" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingRight: 8 }}>
      <div style={{backgroundColor: codeColor}} className="code-search-tab-color"></div>
      <div className="code-tab-header">
        <div className="flex-row">
          <div style={{display: "none"}} className='code-search-tab-code-type'>
            {/* CPT<br/> */}
            <div style={{justifyContent: "center"}} className="flex-column code-type">
              
              {section && (
                <span>
                  <b>{section}</b>
                  {subSection ? <br/> : ''}
                  {subSection ? (
                    <span style={{opacity: 0.7}}>{subSection}</span>
                  ) : ''}
                
                </span>
              )}
              <p>suppper</p>
              {codes[code] !== undefined ? (
                <h2>lfg</h2>
              ):null}

            </div>
            
          </div>
        
          <div style={{minWidth: 53,marginLeft: 7}} className="flex-row align-center">
            {renderLucideIcon(primaryIcon, primaryIconColor)}
            {renderLucideIcon(secondaryIcon, secondaryIconColor)}
            
          </div>
          <p>{code}</p>

          


          <div style={{justifyContent: "center"}} className="flex-column code-type">
            {section && (
              <span>
                <b className='ellipsis' style={{fontSize: 11}}>{section}</b>
                {subSection ? <br/> : ''}
                {subSection ? (
                  <span className='code-type-sub-section' style={{opacity: 0.7}}>{subSection}</span>
                ) : ''}
              
              </span>
            )}
            {codes[code] !== undefined && desc.length > 0 ? (
              <div style={{position: "relative"}} className='flex-row align-center'>
                <NotebookText style={{position:"absolute",left: -3,top: 9,opacity: 0.7}} size={15} color={theme === 'dark' ? '#b3b3b3' : '#333'} />
                <p style={{fontSize: 11, opacity: 0.7,margin: 0,marginTop: 11,marginLeft: 17}}>{desc}</p>
              </div>
              
            ):null}
          </div>
          
        </div>
        <div className="flex-row align-center">
          <button
              onClick={handleCopy}
              className={`copy-button-circle ${theme}`}
              aria-label="Copy code"
            >
              <Copy size={12} color={theme === 'dark' ? '#b3b3b3' : '#333'} />
          </button>
          <button
            onClick={() => onCloseClick(code)}
            className={`close-button-circle ${theme}`}
            aria-label="Remove code"
          >
            <X size={14} color={theme === 'dark' ? '#b3b3b3' : '#333'} />
          </button>

        </div>

        

      </div>
      
      { codes[code] !== undefined && (
        <div className="code-tab-footer">
          {codes[code] !== undefined && Object.keys(codes[code].data).length > 0 ? (
            <div className='table-wrapper'>
              <table>
                <thead>
                  <tr>
                    <th>Price Source</th>
                    <th>
                      <div style={{justifyContent: "space-between"}} className='flex-row align-center'>
                        <div className="percent"> {renderPercentColor(markupPercent, true)}<span className="mute">%</span></div>
                        <div className="flex-row align-center">
                          <Hospital style={{marginRight: 11}} size={18} color={primaryIconColor} /> Facility
                        </div>
                      </div>
                    </th>
                    <th>
                      <div style={{justifyContent: "space-between"}} className='flex-row align-center'>
                        <div className="percent"> {renderPercentColor(markupPercent, true)}<span className="mute">%</span></div>
                        <div className="flex-row align-center">
                          <Stethoscope style={{marginRight: 11}} size={15} color={primaryIconColor} /> Non-Facility
                        </div>
                        
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  { Object.keys(codes[code].data).map((key,i) => {
                      return (
                      <tr key={i}>
                        <td className='data-label'>{priceSources[key]?.name || key}</td>
                        <td className='data-value'>
                          {codes[code].data[key].facilityPrice?.price && 
                          codes[code].data[key].facilityPrice?.price !== 'NaN'&& 
                          codes[code].data[key].facilityPrice?.price !== 'N/A' ? (
                            <span><span className="dollar-sign">$</span>{addCommas(renderMarkup(codes[code].data[key].facilityPrice?.price))}</span>
                          ):'--'}
                        </td>
                        <td className='data-value'>
                          {codes[code].data[key].nonfacilityPrice?.price && 
                          codes[code].data[key].nonfacilityPrice?.price !== 'NaN'&& 
                          codes[code].data[key].nonfacilityPrice?.price !== 'N/A' ? (
                            <span>
                              <span className="dollar-sign">$</span>{addCommas(renderMarkup(codes[code].data[key].nonfacilityPrice?.price))}</span>
                          
                          ):'--'}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          ):(
            <p style={{fontSize: 11, opacity: 0.7,margin: 0}}>No data</p>
          )}
          
        </div>


      )}
      {codes[code] === undefined && (
        <div className="code-tab-status" aria-live="polite">
          {loading ? (
            <><span className="lookup-spinner" /> Loading pricing…</>
          ) : (
            'No pricing data found for this code.'
          )}
        </div>
      )}
      
      

    
      
    </div>
  );
};

export default CodeSearchTab;
